var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40.024 216.09 40 104.16c0-6.594 5.343-11.938 11.937-11.937l18.335.004c6.594.002 11.94 5.348 11.942 11.943l.014 65.444L208.927 42.916c3.888-3.888 10.19-3.888 14.079 0l14.078 14.078c3.888 3.888 3.888 10.191 0 14.08L110.386 197.771l65.444.014c6.595.001 11.942 5.348 11.943 11.943l.004 18.334c.001 6.594-5.343 11.937-11.938 11.937l-111.929-.024c-13.188-.003-23.882-10.698-23.886-23.886"
})));
export default SvgArrowDownLeft;